export enum PricesAvailablePartsOrdering {
  PartCode = 'PartCode',
  ManufacturerCode = 'ManufacturerCode',
  Name = 'Name',
  Description = 'Description',
}
